import { defineMessages } from 'react-intl';

export default defineMessages({
  billingAddressBlockTitle: {
    id: 'components.SelectBillingAddress.billingAddressGroupTitle',
    description: 'Billing Address Group title',
    defaultMessage: 'Billing Address',
  },
  sameBilling: {
    id: 'components.SelectBillingAddress.sameBilling',
    description: 'Billing Address Option Same as Shipping',
    defaultMessage: 'Billing Address Same as Shipping',
  },
  differentBilling: {
    id: 'components.SelectBillingAddress.differentBilling',
    description: 'Billing Address Option Different Address',
    defaultMessage: 'Use a Different Billing Address',
  },
  billingInfoTitle: {
    id: 'components.SelectBillingAddress.billingInfoTitle',
    description: 'Billing info title',
    defaultMessage: 'Billing info',
  },
  required: {
    id: 'Checkout.SelectBillingAddress.required',
    description: 'Required label',
    defaultMessage: 'Required',
  },
  invalidEmail: {
    id: 'Checkout.SelectBillingAddress.invalidEmail',
    description: 'Invalid email label',
    defaultMessage: 'Enter valid email address. Field cannot be blank.',
  },
  invalidPhone: {
    id: 'Checkout.SelectBillingAddress.invalidPhone',
    description: 'Invalid phone label',
    defaultMessage: 'Phone number must be 10 digits. (000) 000-0000',
  },
  invalidFirstName: {
    id: 'Checkout.SelectBillingAddress.invalidFirstName',
    description: 'Invalid first name',
    defaultMessage: 'Invalid first name',
  },
  invalidLastName: {
    id: 'Checkout.SelectBillingAddress.invalidLastName',
    description: 'Invalid last name',
    defaultMessage: 'Invalid last name',
  },
  notAcceptedPOBox: {
    id: 'Checkout.SelectBillingAddress.notAcceptedPOBox',
    description: 'P.O. Boxes are not accepted.',
    defaultMessage: 'P.O. Boxes are not accepted.',
  },
  requiredFirstName: {
    id: 'Checkout.SelectBillingAddress.requiredFirstName',
    defaultMessage: 'Enter first name. Field cannot be blank.',
  },
  requiredStreetName: {
    id: 'Checkout.SelectBillingAddress.requiredStreetName',
    defaultMessage: 'Enter street address. Field cannot be blank.',
  },
  requiredZipCode: {
    id: 'Checkout.SelectBillingAddress.requiredZipCode',
    defaultMessage: 'Enter valid zip code',
  },
  requiredCity: {
    id: 'Checkout.SelectBillingAddress.requiredCity',
    defaultMessage: 'Enter city. Field cannot be blank.',
  },
  requiredState: {
    id: 'Checkout.SelectBillingAddress.requiredState',
    defaultMessage: 'Select a state',
  },
  requiredLastname: {
    id: 'Checkout.SelectBillingAddress.requiredLastname',
    defaultMessage: 'Enter last name. Field cannot be blank.',
  },
});
